export const useMabStore = defineStore('mab', {
  actions: {
    async getIdentStatus(sessionId: string): Promise<MabIdentificationStatus> {
      const { mabRepository, directMabRepository } = useLegacyApi()
      const { isDirectSign } = useDirectSignStore()

      return isDirectSign ? directMabRepository.getIdentStatus(sessionId) : mabRepository.getIdentStatus(sessionId)
    },
    async getMabIdentSessionStatus(sessionId: string): Promise<MabIdentificationStatus> {
      const { directMabRepository } = useLegacyApi()

      return directMabRepository.getMabIdentSessionStatus(sessionId)
    },
    async getRedirectQueryParams(sessionId: string): Promise<string> {
      const { directMabRepository } = useApi()

      return await directMabRepository.getRedirectQueryParams(sessionId)
    },
    async createStandaloneIdentParRequest(legislation: Legislation): Promise<{ url: string }> {
      const languageStore = useLanguageStore()
      const { mabRepository } = useLegacyApi()
      return await mabRepository.createStandaloneIdentParRequest(languageStore.language || 'en', legislation)
    },
    async createIdentParRequest(
      signatureRequestId: string,
      signatureId: string,
      legislation: Legislation
    ): Promise<{ url: string }> {
      const languageStore = useLanguageStore()
      const { mabRepository } = useLegacyApi()
      return await mabRepository.createIdentParRequest(
        signatureRequestId,
        signatureId,
        languageStore.language || 'en',
        legislation
      )
    },
    async createNasIdentParRequest(signatureRequestId: string, signatureId: string): Promise<{ url: string }> {
      const languageStore = useLanguageStore()
      const { directMabRepository } = useLegacyApi()

      return await directMabRepository.createIdentParRequest(
        signatureRequestId,
        signatureId,
        languageStore.language || 'en'
      )
    },
    async redirectIdent(sessionId: string, params: Record<string, string | string[]>): Promise<RedirectResponse> {
      const { mabRepository } = useLegacyApi()
      return await mabRepository.redirectIdent(sessionId, params)
    },
    async createSignCibaRequest(
      signatureRequestId: string,
      signatureId: string,
      redirectQueryParams: RedirectQueryParams = {}
    ): Promise<CreateCibaResponse> {
      const languageStore = useLanguageStore()
      const { directMabRepository } = useLegacyApi()

      return await directMabRepository.createSignCibaRequest(
        signatureRequestId,
        signatureId,
        languageStore.language || 'en',
        redirectQueryParams
      )
    },
    async acceptTermsOfUse(sessionId: string): Promise<void> {
      const { mabRepository, directMabRepository } = useLegacyApi()
      const { isDirectSign } = useDirectSignStore()

      if (isDirectSign) {
        await directMabRepository.acceptTermsOfUse(sessionId)
      } else {
        await mabRepository.acceptTermsOfUse(sessionId)
      }
    },
    async getMabIdentSessionInfo(signatureRequestId: string, signatureId: string): Promise<MabIdentSessionInfo> {
      const { directMabRepository } = useLegacyApi()

      return await directMabRepository.getMabIdentSessionInfo(signatureRequestId, signatureId)
    },
  },
})
